/**
 * Sandbox policy figures shown to the customer.
 *
 * These have already moved more than once (concurrency 5 -> 1, verified cap
 * 5 -> 3), so they live here rather than inline in copy. Anything the API
 * reports at runtime - the verified cap and the total cap, both on the list
 * response - should be read from the API instead; the values here are only for
 * figures no endpoint exposes yet.
 */

export interface SandboxComparisonRow {
  label: string
  sandbox: string
  unlocked: string
  /** Renders as a badge rather than plain text when both sides are the same yes. */
  isBoolean?: boolean
}

/** Fallbacks for the caps, used only until the list response has loaded. */
export const SANDBOX_VERIFIED_CAP_FALLBACK = 3
export const SANDBOX_TOTAL_CAP_FALLBACK = 5

export const SANDBOX_CONCURRENCY = 1
export const UNLOCKED_CONCURRENCY = 50

/**
 * Deliberately NOT a rupee figure.
 *
 * The signup grant is an AMS prod config value (`onboarding_credits_inr`) that
 * finance can change without touching this repo, and the compliance top-up has
 * no implementation yet. Naming an amount here promised money the backend does
 * not guarantee, and it would silently rot the day the config moves. Describe
 * the shape of the benefit; quote figures once a credit API can source them.
 */
export const SANDBOX_CREDIT = 'Starter credit'
export const UNLOCK_CREDIT_BONUS = 'Additional credit'

export const COMPLIANCE_DOCUMENTS = 'COI or Udyam, plus PAN or GST'
export const COMPLIANCE_REVIEW_TIME = 'about an hour'

export const getSandboxComparison = (verifiedCap: number): SandboxComparisonRow[] => [
  {
    label: 'Phone number',
    sandbox: '1 Plivo test number',
    unlocked: 'Rent your own',
  },
  {
    label: 'Inbound: apps, trunks, streaming, agents',
    sandbox: 'Yes',
    unlocked: 'Yes',
    isBoolean: true,
  },
  {
    label: 'Outbound',
    sandbox: `${verifiedCap} verified numbers`,
    unlocked: 'Any Indian number',
  },
  {
    label: 'Concurrency',
    sandbox: `${SANDBOX_CONCURRENCY} call`,
    unlocked: `${UNLOCKED_CONCURRENCY} calls`,
  },
  {
    label: 'Credit',
    sandbox: SANDBOX_CREDIT,
    unlocked: UNLOCK_CREDIT_BONUS,
  },
]
